define([
	"dojo/_base/declare",
	"csi/table/New",
	"Apparel/StructureItemActionMixin"
], function(declare,New,StructureItemActionMixin) {

	return declare([New, StructureItemActionMixin], {
		/**
		 * Add special controller for new form
		 */
		onCreatePopupDefView: function(defView) {
			this._mixinActionView(defView);
		}
	});
});